// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 424) return "js/424.js";
	if (chunkId === 861) return "js/861.js";
	// return url for filenames based on template
	return undefined;
};